import React, { useEffect, useMemo, useRef, useState } from "react";
import { toast } from "react-toastify";
import { io } from "socket.io-client";
import { ReactComponent as OfflineSvg } from "../assets/icons/offline.svg";

const socketUri = import.meta.env.SOCKET_URI;
const socketPath = import.meta.env.SOCKET_PATH;

export const SocketContext = React.createContext({
  socket: undefined,
  connect: () => {},
  disconnect: () => {},
  onNewIncomingMessage: () => {},
  emit: (to, event, message) => {},
});

const SocketProvider = ({ children }) => {
  const [socket, setSocket] = useState(undefined);
  const [userId, setUserId] = useState(undefined);
  const toastId = useRef(null);

  const connect = (token, userId, userType, company) => {
    let _toastId = undefined;

    setUserId(userId);

    const _socket = io(socketUri, {
      path: socketPath,
      autoConnect: false,
      auth: {
        token,
      },
      query: {
        type: userType ?? "user",
        user: userId,
        company: company ?? "",
      },
    });

    _socket.on("connect", () => {
      console.log("🔌 Socket Connected");
      setSocket(_socket);
      setUserId(userId);

      // * Remove toast if present
      if (toastId.current) {
        console.log("Closing toast");
        toast.dismiss(toastId.current);
      }
    });

    _socket.on("connect_error", (error) => {
      console.error("connect_error", error);
    });

    _socket.on("error", (error) => {
      console.error("Socket Error", error);
    });

    _socket.on("disconnect", () => {
      if (!userId) {
        toastId.current = toast.error("You're currently offline", {
          autoClose: false,
          icon: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "fit-content",
                height: "fit-content",
              }}
            >
              <OfflineSvg width={22} />
            </div>
          ),
          closeOnClick: false,
          closeButton: false,
          draggable: false,
        });
      }

      if (userId) {
        setUserId(undefined);
      }

      console.log("socket toastId", toastId.current);
    });

    console.log("🛟 Connecting...");
    _socket.connect();
  };

  const disconnect = () => {
    try {
      socket.disconnect();
    } catch (error) {
      console.error(error);
    } finally {
      setSocket(null);
    }
  };

  const emit = (to, event, message) => {
    socket.emit("message", {
      to,
      event,
      message,
    });
  };

  const values = useMemo(
    () => ({
      socket,
      connect,
      disconnect,
      emit,
    }),
    [socket]
  );

  return (
    <SocketContext.Provider value={values}>{children}</SocketContext.Provider>
  );
};

export default SocketProvider;
